'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { BetterTooltip } from '@/components/ui/tooltip';
import { CODING_AGENTS_AVAILABILITY_MESSAGE } from '@/lib/billing/coding-agents-entitlement';
import { SETTINGS_TABS } from '@/lib/constants';
import { buildSettingsPath } from '@/utils/app-paths';
export function CodingAgentsUpgradeTooltipContent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span>{CODING_AGENTS_AVAILABILITY_MESSAGE}{" "}<a href={buildSettingsPath({
        tab: SETTINGS_TABS.BILLING
      })} className="text-primary underline">Upgrade in settings</a>.</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function CodingAgentsUpgradeTooltip(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CodingAgentsUpgradeTooltipContent />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <BetterTooltip content={t1}><span className="inline-flex">{children}</span></BetterTooltip>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}